import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const OptionButton = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    height: 100%;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.colors.secondary[200]};
    border-radius: 12px;
    transition: linear 0.2s box-shadow;
    padding: 4rem 0;

    &:hover {
        box-shadow: 0px 4px 10px 0px #00000033;
        transition: linear 0.2s box-shadow;
    }
`;

const Title = styled(Typography)`
    margin-top: 12px;
    margin-bottom: 4px;
`;

const Description = styled(Typography)`
    color: ${({ theme }) => theme.colors.black[600]};
    line-height: normal;
    text-align: center;
    letter-spacing: 0.17px;
`;

interface Props {
    icon: React.ReactNode;
    title: string | React.ReactNode;
    description: string | React.ReactNode;
    onClick?: () => void;
}

function CloneVoiceOptionButton({ icon, title, description, onClick }: Props) {
    return (
        <OptionButton onClick={onClick}>
            {icon}
            <Title variant="h3">{title}</Title>
            <Description variant="body2">{description}</Description>
        </OptionButton>
    );
}

export default CloneVoiceOptionButton;
